import { useEffect, useRef } from 'react';

/** Nested-modal safe scroll lock count */
let scrollLockCount = 0;

export function resetScrollLock() {
    scrollLockCount = 0;
    document.body.classList.remove('sp-scroll-locked');
    document.documentElement.classList.remove('sp-scroll-locked');
    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';
    const main = document.querySelector('.app-main');
    if (main) delete main.dataset.scrollLock;
}

function lockScroll() {
    scrollLockCount += 1;
    if (scrollLockCount === 1) {
        document.body.classList.add('sp-scroll-locked');
        document.documentElement.classList.add('sp-scroll-locked');
    }
}

function unlockScroll() {
    scrollLockCount = Math.max(0, scrollLockCount - 1);
    if (scrollLockCount === 0) {
        document.body.classList.remove('sp-scroll-locked');
        document.documentElement.classList.remove('sp-scroll-locked');
        document.body.style.overflow = '';
        document.documentElement.style.overflow = '';
    }
}

/**
 * Locks page scroll while a modal is open and closes on Escape.
 * Uses a ref for onClose so identity changes don't remount the lock.
 */
export function useModalA11y({ onClose, isOpen = true }) {
    const onCloseRef = useRef(onClose);
    onCloseRef.current = onClose;

    useEffect(() => {
        if (!isOpen) return undefined;

        lockScroll();

        const onKeyDown = (e) => {
            if (e.key === 'Escape' && typeof onCloseRef.current === 'function') {
                e.preventDefault();
                onCloseRef.current();
            }
        };

        document.addEventListener('keydown', onKeyDown);
        return () => {
            document.removeEventListener('keydown', onKeyDown);
            unlockScroll();
        };
    }, [isOpen]);
}
